import phantom from './phantom';
export default phantom;



// WEBPACK FOOTER //
// ./src/services/phantom/index.js